
const state = {
    loading: false,
    snackbar: {
        show: false,
        text: '',
        color: '',
    }
}

const getters = {
    getLoading: (state) => state.loading,
    getSnackBar: (state) => state.snackbar,
}

const mutations = {
    CHANGE_LOADING(state,value){
        state.loading = value
    },
    SET_SNACKBAR(state,value){
        state.snackbar = value
    }

}

const actions = {

}

export default {
    state,
    mutations,
    getters,
    actions
}
